<template>
    <v-dialog :value="value" @save="save" max-width="800" persistent>
        <template>
              <v-card tile>
                <v-card-title>
                  <h3>{{ dialogTitle }}</h3>
                  <v-spacer></v-spacer>
                  <v-icon @click="close" color="primary">close</v-icon>
                </v-card-title>
                <v-form
                  ref="userForm"
                  >
                <v-card-text>
            <v-row>
                <v-col cols="12" sm="6" md="6">
                    <v-text-field
                    label="Name"
                    v-model="fullName"
                    :rules="[inputRules.required]"
                    outlined></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <v-text-field
                    label="Bentzername"
                    :rules="[inputRules.required]"
                    outlined
                    v-model="email"></v-text-field>
                </v-col>
            </v-row>
                <v-row>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field
                                label="Passwort"
                                v-model="password"
                                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPass ? 'text' : 'password'"
                                @click:append="showPass = !showPass"
                                :rules="[!this.user ? inputRules.required : null]"
                                outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field
                                label="Passwort wiederholen"
                                v-model="rePassword"
                                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPass ? 'text' : 'password'"
                                :rules="[!this.user ? inputRules.required : null]"
                                @click:append="showPass = !showPass"
                                outlined></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6" md="6">
                    <v-select
                            label="Rolle"
                            :items="roles"
                            v-model="selectedRole"
                            persistent-hint
                            return-object
                            outlined
                    ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" v-if="isSuperAdmin && !editedUserIsSuperAdmin">
                        <v-select
                                :items="customers"
                                label="Kunde"
                                v-model="selectedCustomer"
                                item-text="name"
                                item-value="id"
                                persistent-hint
                                return-object
                                outlined
                        ></v-select>
                    </v-col>
                </v-row>
                <v-container v-if="!editedUserIsSuperAdmin">
                  <v-input>
                      Produkte
                  </v-input>
                  <v-card
                      v-if="!editedUserIsSuperAdmin"
                          class="d-flex flex-wrap"
                          flat
                          tile
                  >
                          <v-checkbox  v-for="item in productsOfCurrentCustomer"
                                       :key="item.id"
                                       class="pa-2"
                                       v-model="selectedProducts"
                                       :label="item.name"
                                       :value="item.id"
                                       outlined>
                          </v-checkbox>
                  </v-card>
                </v-container>
                  <v-row>
                    <v-col
                           md="10"></v-col>
                    <v-col
                           md="2"
                    class="pa-0">
                      <v-btn color="primary" class="ma-0" style="text-align: right" @click="save" :disabled="!canSave">Speichern</v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
                </v-form>
              </v-card>
        </template>
    </v-dialog>
</template>
<!-- TODO change lang to ts instead js to enable typescript-->
<script lang="js">
    import rolesApi from '@/api/roles'
    import usersApi from '@/api/users'
    import customersApi from '@/api/customers'
    import sessionStore from "@/stores/AuthStore";
    import productsApi from "@/api/products"
    import ErrorStore from "@/stores/ErrorStore";
    import SortUtil from "@/utils/sortUitl";
    export default {
        name: "UserDetails",
        props: ['user', 'value'],
        components: {
        },
        data () {
            return {
                currentUser: this.user,
                accessToken: this.user ? this.user.access_token : null,
                email: this.user ? this.user.email : '',
                fullName: this.user ? this.user.fullname : '',
                canSave: true,
                password: null,
                rePassword: null,
                selectedRole: this.roleSelected(),
                customers: [],
                selectedCustomer: null,
                selectedProducts: this.user ? this.user.products.map(it => it.id) : [],
                products: [],
                valid: false,
                showPass: false,
                inputRules: {
                  required: value => !!value || 'Dieses Feld ist erforderlich.',
                  email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                  }
                }
            }
        },
      watch: {
        selectedCustomer () {
          this.user ? this.user.products.map(it => it.id) : []
        }
      },
      computed: {
          roles() {
            if(sessionStore.state.isSuperAdmin()){
              return ['SUPERADMIN', 'ADMINISTRATOR', 'NUTZER']
            } else {
              return ['ADMINISTRATOR', 'NUTZER']
            }
          },
          dialogTitle () {
              return this.user ? 'Nutzer bearbeiten' : 'Neuer Nutzer'
          },
          isSuperAdmin () {
              return sessionStore.state.isSuperAdmin()
          },
          editedUserIsSuperAdmin () {
            return this.selectedRole === 'SUPERADMIN'
          },
          productsOfCurrentCustomer () {
            if (this.isSuperAdmin) {
              return this.products.filter(p => this.selectedCustomer && p.customer.id === this.selectedCustomer.id)
            } else {
              return this.products.filter(p => sessionStore.state.user && p.customer.id === sessionStore.state.user.customer.id)
            }
          }
      },
      mounted() {
          if (this.isSuperAdmin) {
              this.getCustomers()
          } else {
              this.getProducts()
          }
      },
        methods: {
          save() {
            if (this.$refs.userForm.validate()) {
              if (this.user) {
              usersApi.createOrUpdateUser({
                'access_token': this.accessToken,
                fullname: this.fullName,
                email: this.email,
                password: this.password ? this.password : null,
                're_password': this.rePassword ? this.rePassword : null,
                role: this.getRoles()[this.selectedRole],
                'customer_id': this.editedUserIsSuperAdmin ? null : this.selectedCustomer ? this.selectedCustomer.id : null,
                products: this.editedUserIsSuperAdmin ? null : this.selectedProducts
              })
                  .then(_ => {
                        this.close()
                        ErrorStore.showErrorMessage('Benutzer wurde bearbeitet', 'Info')
                      }
                  )
                  .catch(err => ErrorStore.showError(err.response.data))

            } else {
              usersApi.createOrUpdateUser({
                fullname: this.fullName,
                email: this.email,
                password: this.password ? this.password : null,
                're_password': this.rePassword ? this.rePassword : null,
                role: this.getRoles()[this.selectedRole],
                'customer_id': this.editedUserIsSuperAdmin ? null : this.selectedCustomer ? this.selectedCustomer.id : null,
                products: this.editedUserIsSuperAdmin ? null : this.selectedProducts
              })
                  .then(_ => {
                    this.close()
                    ErrorStore.showErrorMessage('Benutzer wurde angelegt', 'Info')
                  })
                  .catch(err => ErrorStore.showError(err.response.data))

            }
            }
          },
          close() {
            this.email = ''
            this.fullName = ''
            this.password = null
            this.rePassword = null
            this.selectedProducts = []
            this.$emit('close')
          },
          getRoles() {
            return rolesApi.getRoles()
          },
          getCustomers() {
            customersApi.getCustomers().then(r => {
              this.customers = SortUtil.sortedNames(r.data)
              this.selectedCustomer = this.user && this.user.customer ? this.user.customer : this.customers[0]
              this.getProducts()
            })
          },
          getProducts() {
            productsApi.getProducts().then(r => {
              this.products = SortUtil.sortedNames(r.data)
            })
          },
          roleSelected() {
            const rolesEnum = this.getRoles()
            return this.user ? Object.keys(rolesEnum).find(key => rolesEnum[key] === this.user.role.identifier)
                : 'NUTZER'
          }
        }
    }
</script>

<style scoped>

</style>